import { Box } from "@mui/material";
import FilterSelect from "@/components/FilterSelect";
import { DEFAULT_FORM_LIST } from "@/constants/visit-note-form-constant";
import { useVisitNoteFormOptions } from "@/hooks/use-visit-note-form-options";
import { createMapper } from "@/utils/utils";
import { VisitNote } from "@/pages/app/provider/patient/patient-list/patient-chart-new/patient-visit-note/encounter/components/ActiveForm";

interface VisitNoteFormsProps {
  onOptionClick: (v: VisitNote) => void;
  selectedForm?: string;
}

const VisitNoteForms = ({
  onOptionClick,
  selectedForm,
}: VisitNoteFormsProps) => {
  const { options } = useVisitNoteFormOptions();

  return (
    <Box width="290px">
      <FilterSelect
        disableSortOptions
        clearable={false}
        placeholder="Visit Note Type"
        options={options}
        value={selectedForm ?? null}
        onChange={(val) => {
          if (val) {
            onOptionClick(val as VisitNote);
          }
        }}
      />
    </Box>
  );
};

export default VisitNoteForms;

export const ENCOUNTER_FORM_MAPPER = createMapper(
  DEFAULT_FORM_LIST.map((it) => ({ value: it.value, label: it.name }))
);
